import { render, staticRenderFns } from "./EditPlanProject.vue?vue&type=template&id=8b9a3b86&scoped=true"
import script from "./EditPlanProject.vue?vue&type=script&lang=js"
export * from "./EditPlanProject.vue?vue&type=script&lang=js"
import style0 from "./EditPlanProject.vue?vue&type=style&index=0&id=8b9a3b86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9a3b86",
  null
  
)

export default component.exports